import React, { Fragment } from "react";
import { useIntl } from 'react-intl';

import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TabsSection from "@components/TabsSection/tabsSection";
import TermsOfServiceTab from './tabs/termsOfService';
import RefundPolicyTab from './tabs/refundPolicy';
import ReferralProgrammeTab from './tabs/referralProgramme';
import PrivacyPolicyTab from './tabs/privacyPolicy';
import PartnersTab from './tabs/partners';
import DataPolicyTab from './tabs/dataPolicy';
import CookiesTab from './tabs/cookies';
import ReportingChannelTab from './tabs/reportingChannel';

const heroImage = {
  url: `${process.env.CDN_URL}/images/terms-hero-image.jpg`,
  alt: 'Terms and Conditions Hero Image'
};

const TermsTemplate = ({ pageContext: { locale, activeTab, pageSlug } }) => {
  const intl = useIntl();
  const tabs = {
    'terms-of-service': {
      title: intl.formatMessage({ id: 'Terms of Service' }),
      components: [TermsOfServiceTab]
    },
    'refund-policy': {
      title: intl.formatMessage({ id: 'Refund Policy' }),
      components: [RefundPolicyTab],
    },
    'referral-programme': {
      title: intl.formatMessage({ id: 'Referral Programme' }),
      components: [ReferralProgrammeTab],
    },
    'privacy-policy': {
      title: intl.formatMessage({ id: 'Privacy Policy' }),
      components: [PrivacyPolicyTab]
    },
    'partners': {
      title: intl.formatMessage({ id: 'Partners' }),
      components: [PartnersTab]
    },
    'data-policy': {
      title: intl.formatMessage({ id: 'Data Policy' }),
      components: [DataPolicyTab]
    },
    'cookies': {
      title: intl.formatMessage({ id: 'Cookies' }),
      components: [CookiesTab]
    }
  };

  if (locale === 'pt') {
    tabs['reporting-channel'] = {
      title: intl.formatMessage({ id: 'Reporting Channel' }),
      components: [ReportingChannelTab]
    };
  }

  return (
    <Fragment>
      <CustomSEO image={heroImage} title={tabs[activeTab].title} locale={locale} />
      <HeroSection
        heroHeading={intl.formatMessage({ id: 'Terms & Conditions'})}
        heroImage={heroImage}
        height={240}
        lazyload={false}
      />
      <UniplacesFullContainer>
        <React.Fragment>
          <TabsSection
            tabs={tabs}
            defaultTab={activeTab ? activeTab : Object.keys(tabs)[0]}
            locale={locale}
            pageSlug={pageSlug}
          />
          <Controls />
        </React.Fragment>
      </UniplacesFullContainer>
    </Fragment>
  );
};

const CustomSEO = ({
  image,
  title,
  locale,
}) => {
  const intl = useIntl();
  const metaTitle = `${intl.formatMessage({ id: 'Terms & Conditions' })} - ${title}`;
  const metaDescription = `${intl.formatMessage({
    id: 'Terms of Service, Refund Policy, Privacy Policy, Data policy, Cookies, Partners, Referral Programme'
  })}`;

  return (
    <SEO
      title={metaTitle}
      description={metaDescription}
      imageUrl={image.url}
      lang={locale}
    />
  );
};

export default TermsTemplate;
